<template>
    <div class="goods-list" v-loading="loading">
        <div class="block-container">
            <div class="box type">
                <div class="name">类别:</div>
                <div class="value">
                    <!-- <span @click="load()">刷新</span> -->
                    <el-tag :effect="filters.type === 2 ? 'dark' : 'plain'" @click="filters.type = 2" @close="filters.type = 3">
                        出售
                    </el-tag>
                    <el-tag :effect="filters.type === 3 ? 'dark' : 'plain'" @click="filters.type = 3" @close="filters.type = 2">
                        出租
                    </el-tag>
                </div>
            </div>
            <div class="box city">
                <div class="name">地区:</div>
                <div class="value">
                    <!-- <span @click="load()">刷新</span> -->
                    <el-tag v-for="(item, i) in area.province" :key="item.id" :closable="filters.province_id == item.id" :effect="filters.province_id == item.id ? 'dark' : 'plain'" v-if="filters.province_id == 0 || filters.province_id == item.id" @click="filters.province_id = item.id" @close="filters.province_id = 0">
                        {{ item.shortname }}
                    </el-tag>
                    <template v-if="filters.province_id != 0">
                        <el-tag
                            v-for="(item, i) in area.province.find(v => {
                                if (v.id == filters.province_id) {
                                    return v
                                }
                            }).child"
                            :key="item.id"
                            :closable="filters.city_id == item.id"
                            :effect="filters.city_id == item.id ? 'dark' : 'plain'"
                            @click="filters.city_id = item.id"
                            @close="filters.city_id = 0"
                        >
                            {{ item.shortname }}
                        </el-tag>
                    </template>
                </div>
            </div>
            <div class="box price">
                <div class="name">价格:</div>
                <div class="value">
                    <!-- <span @click="load()">刷新</span> -->
                    <!-- :closable="filters.min_price === item.min_price" -->

                    <el-tag
                        v-for="(item, i) in priceList"
                        :key="item.id"
                        :effect="filters.min_price === item.min_price ? 'dark' : 'plain'"
                        @click="
                            filters.min_price = item.min_price
                            filters.max_price = item.max_price
                        "
                        @close="
                            filters.min_price = ''
                            filters.max_price = ''
                        "
                    >
                        {{ item.name }}
                    </el-tag>
                </div>
            </div>
        </div>

        <!-- 搜索关键字 -->
        <div class="search_bread" v-if="keyword">
            <span>搜索结果：</span>
            <span class="keyword">'{{ keyword }}'</span>
        </div>
        <div class="search_bread" v-else-if="!keyword && catewords">
            <span>搜索结果:：</span>
            <span class="keyword">'{{ catewords }}'</span>
        </div>

        <div class="list-wrap">
            <div class="list">
                <!-- 排序筛选区 -->
                <div>
                    <div class="sort">
                        <div class="item" @click="changeSort('')" :class="{ active: filters.order==''}">
                            <div class="item-name">综合</div>
                        </div>
                        <div class="item" @click="changeSort('discount_price')" :class="{ active: filters.order=='discount_price'}">
                            <div class="item-name">价格</div>
                            <i v-if="filters.order === 'discount_price' && filters.sort === 'desc'" class="el-icon-arrow-down el-icon--down" />
                            <i v-else class="el-icon-arrow-up el-icon--up" />
                        </div>
                        <!-- <div class="item-other">
              <el-checkbox label="包邮" v-model="is_free_shipping"></el-checkbox>
            </div> -->
                        <div class="item-other">
                            <!-- <el-checkbox label="自营" v-model="is_own"></el-checkbox> -->
                        </div>
                        <!-- <div class="input-wrap">
							<div class="price_range">
								<el-input placeholder="最低价格" size="small" v-model="filters.min_price"></el-input>
								<span>—</span>
								<el-input placeholder="最高价格" size="small" v-model="filters.max_price"></el-input>
							</div>
							<el-button plain size="mini" @click="handlePriceRange">确定</el-button>
						</div> -->
                    </div>
                </div>
                <div class="cargo-list" v-if="cargoList.length">
                    <div class="goods-info">
                        <div class="item" v-for="(item, index) in cargoList" :key="item.goods_id" @click="$router.pushToTab({ path: '/used-detail-' + item.id })">
                            <img class="img-wrap" :src="$img(item.thumb)" @error="item.thumb = defaultGoodsImage" />
                            <div class="price-wrap">
                                <div class="price" v-if="item.price <= 0">
                                    <!-- <p>￥</p> -->
                                    面议
                                </div>
                                <div class="price" v-else>
                                    <p>￥</p>
                                    {{ item.price }}
                                </div>
                                <div class="area">
                                    {{ item.area.name }}
                                </div>
                                <!-- <div class="market-price">￥{{ item.market_price }}</div> -->
                            </div>
                            <div class="goods-name">{{ item.title }}</div>
                            <div class="shop_name">{{ item.site.site_name }}</div>
                        </div>
                    </div>
                    <div class="pager">
                        <el-pagination background :pager-count="5" :total="total" prev-text="上一页" next-text="下一页" :current-page.sync="currentPage" :page-size.sync="pageSize" @size-change="handlePageSizeChange" @current-change="handleCurrentPageChange" hide-on-single-page></el-pagination>
                    </div>
                </div>
                <div class="empty" v-else>
                    <div class="ns-text-align">没有找到您想要的设备。换个条件试试吧</div>
                </div>
            </div>

            <!-- <div class="goods-recommended" v-if="cargoList.length">
				<goods-recommend :page-size="cargoList.length < 5 ? 2 : 5" />
			</div> -->
        </div>
    </div>
</template>

<script>
    import BreadCrumbs from "@/components/BreadCrumbs"
    // import GoodsRecommend from "@/components/GoodsRecommend";
    import index from "./public/index"

    export default {
        name: "index",
        components: {
            BreadCrumbs
            // GoodsRecommend
        },
        data: () => {
            return {}
        },
        mixins: [index],
        created() {},
        methods: {}
    }
</script>

<style lang="scss" scoped>
    .goods-list {
        background: #fff;
        padding-top: 10px;
    }

    .search_bread {
        display: inline-block;
        font-size: 14px;
        margin: 0px auto;
        width: 100%;
        padding: 10px;
    }

    .selected_border {
        border: 1px solid $base-color;
    }

    .attr_filter {
        .el-tag {
            margin-right: 5px;
            margin-bottom: 10px;
            border-radius: 0;

            .title {
                color: $base-color;
                font-size: 15px;
            }
        }
    }

    .category {
        margin: 0 auto 10px auto;
        border: 1px solid #eeeeee;

        .brand {
            border-bottom: 1px solid #eeeeee;
            display: flex;
            flex-direction: row;

            &:last-child {
                border-bottom: none;
            }

            .table_head {
                width: 140px;
                min-width: 140px;
                border-right: 1px solid #eeeeee;
                padding-left: 10px;
                padding-top: 10px;
                background-color: #f2f6fc;
            }

            .table_body {
                flex-grow: 1;

                .initial {
                    margin: 5px auto 10px 10px;

                    span {
                        border: 0;
                        margin: 0;
                        padding: 5px 10px;
                        border: 0;
                        border-radius: 0;

                        &:hover {
                            background-color: $base-color;
                            color: #ffffff;
                        }
                    }
                }

                .content {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    padding: 10px;
                    width: 900px;

                    .brand-item {
                        margin-right: 10px;
                        margin-top: 10px;
                    }

                    .el-card {
                        width: 125px;
                        height: 45px;

                        &:hover {
                            border: 1px solid $base-color;
                            cursor: pointer;
                        }
                    }

                    span {
                        margin: auto 25px;
                    }
                }
            }

            .table_op {
                margin-top: 5px;
                margin-right: 5px;
            }

            .el-image {
                width: 100%;
                height: 100%;
            }
        }
    }

    .list-wrap {
        overflow: hidden;
        display: flex;

        .list {
            // float: left;
            flex: 1;
        }

        .goods-recommended {
            width: 200px;
            background-color: #fff;
            // float: left;
            margin-left: 10px;
        }
    }

    .sort {
        display: flex;
        align-items: center;
        .active{
            background-color:#ff9400;
            color:#fff;
        }
        .item {
            display: flex;
            align-items: center;
            padding: 5px 15px;
            border: 1px solid #f1f1f1;
            border-left: none;
            cursor: pointer;

            &:hover {
                background: $base-color;
                color: #fff;
            }
        }

        .item-other {
            display: flex;
            align-items: center;
            padding: 5px 15px;
            border: 1px solid #f1f1f1;
            border-left: none;
            cursor: pointer;
            display:none;
        }

        .input-wrap {
            display: flex;
            align-items: center;

            .price_range {
                margin-left: 60px;
            }

            span {
                padding-left: 10px;
            }

            .el-input {
                width: 150px;
                margin-left: 10px;
            }

            .el-button {
                margin: 0 17px;
            }
        }

        > div:first-child {
            border-left: 1px solid #f1f1f1;
        }
    }

    .goods-info {
        margin-top: 5px;
        display: flex;
        flex-wrap: wrap;

        .item {
            width: 295px;
            margin: 10px 10px 0 0;
            border: 1px solid #eeeeee;
            // padding-top: 10px;
            position: relative;
            padding-bottom: 5px;
            box-sizing: border-box;
            overflow: hidden;
            &:nth-child(4n) {
                margin-right: initial !important;
            }

            &:hover {
                border: 1px solid $base-color;
            }

            .img-wrap {
                width: 100%;
                height: 198px;
                cursor: pointer;
                padding: 10px;
                box-sizing: border-box;
            }

            .goods-name {
                padding: 0 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                word-break: break-all;
                height: 25px;
                cursor: pointer;

                &:hover {
                    color: $base-color;
                }
            }

            .price-wrap {
                padding: 0 10px;
                display: flex;
                align-items: center;

                .price {
                    display: flex;
                    color: $base-color;
                    font-size: $ns-font-size-lg;

                    p {
                        font-size: $ns-font-size-base;
                        display: flex;
                        align-items: flex-end;
                    }
                }

                .area {
                    flex: 1;
                    color: #5f5f5f;
                    // text-decoration: line-through;
                    margin-right: 0;
                    text-align: right;
                }
            }

            .sale-num {
                padding: 0 10px;
                display: flex;
                color: #838383;
                font-size: $ns-font-size-sm;

                p {
                    color: #4759a8;
                }
            }

            .shop_name {
                padding: 0 10px;
                display: flex;
                color: #838383;
            }

            .saling {
                padding: 0 10px;
                display: flex;
                font-size: $ns-font-size-sm;
                line-height: 1;

                .free-shipping {
                    background: $base-color;
                    color: #ffffff;
                    padding: 3px 4px;
                    border-radius: 2px;
                    margin-right: 5px;
                }

                .is_own {
                    color: #ffffff;
                    background: #ff850f;
                    border: 1px solid;
                    margin-right: 5px;
                    display: flex;
                    align-items: center;
                    padding: 3px 4px;
                    border-radius: 2px;
                }

                .promotion-type {
                    color: $base-color;
                    border: 1px solid $base-color;
                    display: flex;
                    align-items: center;
                    padding: 1px 3px;
                }
            }

            .item-bottom {
                display: flex;
                margin-top: 5px;

                .collection {
                    flex: 1;
                    border: 1px solid #e9e9e9;
                    border-right: none;
                    border-left: none;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }

                .cart {
                    flex: 2;
                    border: 1px solid #e9e9e9;
                    border-right: none;
                    height: 40px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
            }
        }
    }

    .empty {
        margin-top: 45px;
    }

    .pager {
        text-align: center;
        margin-top: 30px;
    }

    .block-container {
        border: 1px solid #eee;
        margin-bottom: 15px;
        .box {
            display: block;
            // overflow: hidden;
            display: flex;
            flex-wrap: wrap;

            .name {
                width: 60px;
                padding: 13px 10px;
            }

            .value {
                flex: 1;
                padding-bottom: 10px;

                .el-tag {
                    margin: 10px 0 0 10px;
                    border: 0;
                    border-radius: 0;
                    cursor: pointer;
                }

                .el-tag--plain {
                    // background-color: ;
                    color: #000;
                }
            }
        }

        .category {
            .row {
                display: flex;
                flex-wrap: wrap;
                border-bottom: 1px solid #eee;
                padding-bottom: 10px;
                margin-right: 10px;
                .cat1 {
                    width: 100px;
                }
                .cat2 {
                    flex: 1;
                }
            }
        }
    }
</style>
